// eslint-disable-next-line no-console
console.log('PRODUCTION')
export const DEBUG = false;
export const DEMO = false;
export const RECAPTCHA_KEY = '6LcplwsTAAAAAHCfuCsRFbLed1oYxJi7kYtcygrn';
export const TINY_MCE_KEY = 'prqih0kj9c6nru56mnpgs6wu830nyez3e7m0jlzqvxa08z3y';
export const STRIPE_KEY = 'pk_live_VVruNzTke9enRIaoNHPv8PHa';
